import { Box, Button, makeStyles, TextField, Typography } from '@material-ui/core'
import axios from 'axios'
import moment from 'moment'
import React, { useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import formatVehicleLabel from './formatVehicleLabel'

const useStyles = makeStyles((theme) => ({
  note: { marginTop: theme.spacing(3), '& .MuiOutlinedInput-notchedOutline': { borderBottom: '1px solid rgba(0, 0, 0, 0.23)' } },
  reason: { marginTop: theme.spacing(2), whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' },
  reject: { color: theme.palette.error.main, borderColor: theme.palette.error.main },
  footer: { '& .MuiButton-root.Mui-disabled': { opacity: 0.5 } }
}))

const ReservationDecisionModal = ({ reservation, decision, onClose, onReviewed, onStale }) => {
  const classes = useStyles()
  const busyRef = useRef(false)
  const [busy, setBusy] = useState(false)
  const [note, setNote] = useState('')
  const [error, setError] = useState('')
  const approving = decision === 'approved'
  const title = approving ? 'Mirato rezervimin' : 'Refuzo rezervimin'

  const saveDecision = async (event) => {
    event.preventDefault()
    if (busyRef.current) return
    if (note.trim().length > 2000) {
      setError('Shënimi lejohet deri në 2000 karaktere.')
      return
    }
    busyRef.current = true
    setBusy(true)
    setError('')
    let reviewed
    let staleMessage
    try {
      const { data } = await axios.post(`vehicle-reservations/manage/${reservation._id}/decision`, {
        decision,
        note: note.trim(),
        revision: reservation.revision || 0
      })
      if (!data.success || !data.data) setError(data.message || 'Vendimi nuk u ruajt. Provoni përsëri.')
      else reviewed = data.data
    } catch (requestError) {
      const message = requestError.response?.data?.message || 'Vendimi nuk u ruajt. Provoni përsëri.'
      if ([404, 409].includes(requestError.response?.status)) staleMessage = message
      else setError(message)
    } finally {
      busyRef.current = false
      setBusy(false)
    }
    if (reviewed) onReviewed(reviewed)
    else if (staleMessage) onStale(staleMessage)
  }

  return (
    <Modal
      show
      className='modal-1'
      aria-labelledby='reservation-decision-title'
      onHide={() => {
        if (!busyRef.current) onClose()
      }}
      backdrop={busy ? 'static' : true}
      keyboard={!busy}
    >
      <Modal.Header closeButton={!busy}>
        <Modal.Title id='reservation-decision-title'>{title}</Modal.Title>
      </Modal.Header>
      <form onSubmit={saveDecision} noValidate aria-busy={busy}>
        <Modal.Body>
          <Typography gutterBottom>
            {approving ? 'A dëshironi ta miratoni këtë kërkesë?' : 'A dëshironi ta refuzoni këtë kërkesë?'}
          </Typography>
          <Typography>
            {reservation.ownerName || '—'} — {reservation.destination}
          </Typography>
          <Typography variant='body2'>
            {moment(reservation.departureDate).format('DD/MM/YYYY')}, {reservation.departureTime}
          </Typography>
          <Typography variant='body2'>{reservation.vehicles.map(formatVehicleLabel).join(', ')}</Typography>
          {reservation.exceptionalCase && (
            <Box className={classes.reason}>
              <Typography variant='subtitle2'>Rast i jashtëzakonshëm</Typography>
              <Typography variant='body2'>{reservation.exceptionReason}</Typography>
            </Box>
          )}
          <TextField
            id='reservation-review-note'
            label='Shënim (opsional)'
            variant='outlined'
            fullWidth
            multiline
            minRows={3}
            inputProps={{ maxLength: 2000 }}
            value={note}
            onChange={(event) => setNote(event.target.value)}
            disabled={busy}
            className={classes.note}
          />
          {error && (
            <Typography role='alert' color='error' className={classes.reason}>
              {error}
            </Typography>
          )}
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <Button onClick={onClose} disabled={busy}>
            Kthehu
          </Button>
          <Button
            type='submit'
            variant='outlined'
            color={approving ? 'primary' : 'default'}
            className={approving ? undefined : classes.reject}
            disabled={busy}
          >
            {busy ? 'Duke ruajtur…' : title}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default ReservationDecisionModal
